export default __webpack_public_path__ + "static/media/pantry2-after2-768w.d2ff70df.webp";